import { gql } from '@apollo/client';

const SIGN_OUT_USER_MUTATION = gql`
  mutation SIGN_OUT_USER_MUTATION {
    signOut
  }
`;

export default SIGN_OUT_USER_MUTATION;
